import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import StripeCouponResource, {
  StripeCouponResource as ResourceClass
} from '@/modules/billing/resources/StripeCouponResource';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';
import { getters, commits } from '@/modules/core/app/helpers/store';

export class StripeCouponService extends BaseService {
  resource: ResourceClass;

  constructor() {
    super();

    this.resource = StripeCouponResource;
  }

  async getPartnershipInvitationCoupon(jurisdictionId?: number): Promise<StripeCoupon | undefined> {
    const couponId: string | undefined = getters.auth.getUser()?.partnershipInvitation?.discountKey;

    if (couponId && !getters.auth.getUser()?.partnershipInvitation?.coupon) {
      commits.auth.setInvitationStripeCoupon(
        await this.getCoupon(couponId, jurisdictionId ? { jurisdictionId } : undefined)
      );
    }

    return getters.auth.getUser()?.partnershipInvitation?.coupon;
  }

  async getCoupon(couponId: string, params?: Params): Promise<StripeCoupon> {
    return this.resource.getCoupon(couponId, params);
  }
}

export default new StripeCouponService();
